if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        if (this._hasChangeListener) {
          return;
        }

        this._hasChangeListener = true;

        this.addEventListener(
          'change',
          (event) => {
            // Check if target is inside this element
            const targetInThisElement = this.contains(event.target);

            // Check if there's a nested variant-selects between this and target
            let hasNestedVariantSelects = false;
            let currentElement = event.target;

            while (currentElement && currentElement !== document.body) {
              if (currentElement.tagName === 'VARIANT-SELECTS') {
                if (currentElement !== this) {
                  hasNestedVariantSelects = true;
                  break;
                } else {
                  break;
                }
              }
              currentElement = currentElement.parentElement;
            }

            // Ignore if target is not in this element or there's a nested variant-selects
            if (!targetInThisElement || hasNestedVariantSelects) {
              return;
            }

            const target = this.getInputForEventTarget(event.target);
            this.updateSelectedSwatchValue(event);
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          },
          true
        ); // Use CAPTURE phase to catch events before they bubble
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}

/* NordicClick: auto-select a valid option combination when a shopper changes an option,
   so they never land on a non-existent ("Unavailable") variant. */
(function () {
  if (window.__mlAutoSelectVariant) return;
  window.__mlAutoSelectVariant = true;
  var cache = {};
  function load(url) {
    if (!url || cache[url]) return;
    cache[url] = 'loading';
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[url] = p.variants || []; })
      .catch(function () { delete cache[url]; });
  }
  function prime() {
    document.querySelectorAll('variant-selects[data-url]').forEach(function (el) { load(el.dataset.url); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prime); else prime();
  document.addEventListener('mouseover', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects[data-url]');
    if (vs) load(vs.dataset.url);
  }, { passive: true });

  document.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects');
    if (!vs || !Array.isArray(cache[vs.dataset.url])) return;
    var groups = Array.prototype.slice.call(vs.querySelectorAll(':scope fieldset, :scope select'))
      .filter(function (g) { return g.closest('variant-selects') === vs; });
    if (groups.length < 2) return;
    var getVal = function (g) {
      if (g.tagName === 'SELECT') return g.value;
      var c = g.querySelector('input:checked');
      return c ? c.value : null;
    };
    var selected = groups.map(getVal);
    var changed = groups.findIndex(function (g) { return g.contains(e.target) || g === e.target; });
    if (changed < 0) return;
    var variants = cache[vs.dataset.url];
    var matches = function (v, upto) {
      for (var i = 0; i <= upto; i++) if (v.options[i] !== selected[i]) return false;
      return true;
    };
    if (variants.some(function (v) { return matches(v, groups.length - 1); })) return;
    // Only adjust options AFTER the one the shopper clicked; never change earlier choices.
    var pool = variants.filter(function (v) { return matches(v, changed); });
    if (!pool.length) return;
    var pick = null;
    // Keep as many later choices as possible; prefer in-stock.
    for (var keep = groups.length - 1; keep >= changed && !pick; keep--) {
      var cands = pool.filter(function (v) { return matches(v, keep); });
      pick = cands.find(function (v) { return v.available; }) || cands[0] || null;
    }
    if (!pick) return;
    groups.forEach(function (g, i) {
      if (i <= changed) return;
      var val = pick.options[i];
      if (g.tagName === 'SELECT') { g.value = val; return; }
      g.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === val; });
    });
  }, true);
})();
